"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReferralsControllerMyCodeV1200Response = instanceOfReferralsControllerMyCodeV1200Response;
exports.ReferralsControllerMyCodeV1200ResponseFromJSON = ReferralsControllerMyCodeV1200ResponseFromJSON;
exports.ReferralsControllerMyCodeV1200ResponseFromJSONTyped = ReferralsControllerMyCodeV1200ResponseFromJSONTyped;
exports.ReferralsControllerMyCodeV1200ResponseToJSON = ReferralsControllerMyCodeV1200ResponseToJSON;
exports.ReferralsControllerMyCodeV1200ResponseToJSONTyped = ReferralsControllerMyCodeV1200ResponseToJSONTyped;
var ReferralCodeResponseDto_1 = require("./ReferralCodeResponseDto");
/**
 * Check if a given object implements the ReferralsControllerMyCodeV1200Response interface.
 */
function instanceOfReferralsControllerMyCodeV1200Response(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function ReferralsControllerMyCodeV1200ResponseFromJSON(json) {
    return ReferralsControllerMyCodeV1200ResponseFromJSONTyped(json, false);
}
function ReferralsControllerMyCodeV1200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, ReferralCodeResponseDto_1.ReferralCodeResponseDtoFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function ReferralsControllerMyCodeV1200ResponseToJSON(json) {
    return ReferralsControllerMyCodeV1200ResponseToJSONTyped(json, false);
}
function ReferralsControllerMyCodeV1200ResponseToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, ReferralCodeResponseDto_1.ReferralCodeResponseDtoToJSON)(value['data']),
        'error': value['error'],
        'errorCode': value['errorCode'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
